import { render, staticRenderFns } from "./package-list.vue?vue&type=template&id=50766520&scoped=true&"
import script from "./package-list.vue?vue&type=script&lang=js&"
export * from "./package-list.vue?vue&type=script&lang=js&"
import style0 from "./package-list.vue?vue&type=style&index=0&id=50766520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50766520",
  null
  
)

export default component.exports